import React from "react";
import styled from 'styled-components';
import "react-step-progress-bar/styles.css";
import { servicesIdTAE } from "../../../constants";

const Container = styled.div`
  width: 100%;
  background: ${props => props.background ? props.background : "transparent"};
`;

const Title = styled.div`
    font-style: ${props => props.style ? props.style : "normal"};
    font-variant: normal;
    font-weight: ${props => props.weight ? props.weight : "normal"};
    font-stretch: normal;
    font-size: ${props => props.fontSize ? props.fontSize : "14px"};
    line-height: normal;
    font-family: ${props => props.fontFamily ? props.fontFamily : "Amx-Bold"};;
    margin: ${props => props.margin ? props.margin : "0rem 1rem 0rem 0rem"};
    padding: ${props => props.padding ? props.padding : "0rem 0rem 0rem 0rem"};
    display: ${props => props.display ? props.display : "inline-block"};
    text-align:  ${props => props.align ? props.align : "left"};
    color: ${props => props.color ? props.color : "rgb(80, 98, 108)"};
`;

const InputTitleClaroSocio = ({ text, textCPay, titleStyle, fontSize, imgHelp, type, handleClickTooltip, isClaroPartner, logicType, serviceId, isContainerTelcel, isFocused, serviceTA }) => {
    let srcHelpImage = (isClaroPartner)? `${process.env.REACT_APP_IMAGES}help_reference_claro_socio.png` : `${process.env.REACT_APP_IMAGES}icono_faq.svg`;
        srcHelpImage = !isClaroPartner && isContainerTelcel ? "/images/icono_signo_de_interrogacion.png" : srcHelpImage;

    let color = "";
    if (isContainerTelcel && isFocused && !serviceTA) {
        color = "#0071d1"
    } else {
        color = (logicType == "sears")? "#000000":"rgb(80, 98, 108)";
        color = logicType !== "sears" && !isClaroPartner && isContainerTelcel ? "#757575" : color;
    }

    let fontFamily = (logicType == "sears")? "Amx-Regular":"Amx-Bold";
        fontFamily = logicType !== "sears" && !isClaroPartner && isContainerTelcel ? "AMX-Bold" : fontFamily;

    let imgStyle = {
        verticalAlign: "bottom",
        width: !isClaroPartner && isContainerTelcel ? "24px" : "1.2em",
        position: "relative",
        top: !isClaroPartner && isContainerTelcel ? "-2px" : "0px",
    }

    let textRef = (type === "ocr" && textCPay && !isContainerTelcel) ? textCPay : text;

    const display = isClaroPartner && servicesIdTAE.includes(serviceId) ? 'none' : 'inline';
    const title = isClaroPartner && servicesIdTAE.includes(serviceId) && textRef === 'CVV' ? `${textRef}:` : textRef;
    
    return(
        <Container background={(logicType !== "sears" && !isClaroPartner && isContainerTelcel) ? "#fff" : false}>
            {
                (titleStyle ? 
                    <Title  
                        {...titleStyle}
                        fontSize = {fontSize}
                        color = {color}
                        fontFamily = {fontFamily}
                        margin = {logicType !== "sears" && !isClaroPartner && isContainerTelcel ? "0px 8px 5px 0px" : false}
                    >
                        {title}
                    </Title> : 
                    <></>
                )
            }
            {
                (
                    imgHelp ?
                    <img 
                        style={imgStyle}
                        src={srcHelpImage}
                        onClick={(e) => handleClickTooltip(e, type)}
                        data_type={type}
                    /> : 
                    <></>
                )
            }
        </Container>
    )
}


export default InputTitleClaroSocio;